module.exports = __webpack_public_path__ + "static/media/Samruddhi Kamthe.7c60916f.jpeg";